__turbopack_context__.v({
  "container": "style-module-scss-module__8YxL6q__container",
});
